import PropTypes from 'prop-types'
import { Form, Input } from 'antd'
import { useIntl } from 'react-intl'

// New password plus its confirmation, shared by the first-sign-in challenge and
// the password reset. Must live inside an antd Form.
const NewPasswordFields = ({ autoFocus = false }) => {
  const intl = useIntl()

  return (
    <>
      <Form.Item
        name="new_password"
        label={intl.formatMessage({ id: 'auth.newPasswordLabel' })}
        rules={[{ required: true, message: intl.formatMessage({ id: 'auth.passwordRequired' }) }]}
      >
        <Input.Password data-testid="new_password" autoComplete="new-password" autoFocus={autoFocus} />
      </Form.Item>
      <Form.Item
        name="confirm_new_password"
        label={intl.formatMessage({ id: 'auth.confirmNewPasswordLabel' })}
        dependencies={['new_password']}
        rules={[
          { required: true, message: intl.formatMessage({ id: 'auth.passwordRequired' }) },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('new_password') === value) {
                return Promise.resolve()
              }
              return Promise.reject(new Error(intl.formatMessage({ id: 'auth.passwordsDoNotMatch' })))
            },
          }),
        ]}
      >
        <Input.Password data-testid="confirm_new_password" autoComplete="new-password" />
      </Form.Item>
    </>
  )
}

NewPasswordFields.propTypes = {
  autoFocus: PropTypes.bool,
}

export default NewPasswordFields
